export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
  },
  ENGAGED: {
    Title: 'Engaged',
    Color: '#E9DFFF',
  },
  PROFILE_PENDING: {
    Title: 'Profile pending',
    Color: '#FFD54F',
  },
  PROFILE_RESUME: {
    Title: 'Profile resume',
    Color: '#B8E6C9',
  },
  INTERVIEW_REVIEW: {
    Title: 'Profile interview',
    Color: '#B3D9F2',
  },
  PROFILE_REVIEW: {
    Title: 'Profile review',
    Color: '#FDC200',
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
  },
};
